module.exports = __webpack_public_path__ + "img/tab1-bg.6b57706.629a4110.png";